import { Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { IconType } from '@kinomap-dev/ng-ui-lib/core';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export type ToastModel = {
  id: number,
  title: string | undefined,
  msg: string,
  type: ToastType,
  icon: IconType | undefined,
  duration: number;
}

@Injectable({
  providedIn: 'root'
})
export class Toaster {

  private _toasts: WritableSignal<ToastModel[]> = signal([]);
  toasts: Signal<ToastModel[]> = this._toasts.asReadonly();

  private show(title: string | undefined, msg: string, type: ToastType, icon: IconType | undefined, duration: number = 3000): number {
    const id: number = Date.now();
    const toast: ToastModel = { id, title, msg, type, icon, duration };
    this._toasts.update(toasts => [...toasts, toast]);
    setTimeout(() => this.remove(id), duration);
    return id;
  }

  remove(id: number): void {
    this._toasts.update((toasts: ToastModel[]) => toasts.filter((t: ToastModel) => t.id !== id));
  }

  success(title: string | undefined, msg: string, icon: IconType | undefined, duration: number = 3000): number {
    return this.show(title, msg, 'success', icon, duration);
  }

  error(title: string | undefined, msg: string, icon: IconType | undefined, duration: number = 3000): number {
    return this.show(title, msg, 'error', icon, duration);
  }

  info(title: string | undefined, msg: string, icon: IconType | undefined, duration: number = 3000): number {
    return this.show(title, msg, 'info', icon, duration);
  }

  warning(title: string | undefined, msg: string, icon: IconType | undefined, duration: number = 3000): number {
    return this.show(title, msg, 'warning', icon, duration);
  }
}
